import React from "react";

import Menu from "../Menu/Menu";
import Backdrop from "../Backdrop/Backdrop";

import classes from "./MenuModal.module.css";

const MenuModal = ({ isActive, closeModal }) => {
  return (
    <>
      <Backdrop isActive={isActive} clicked={closeModal} />
      <div
        className={
          isActive
            ? `${classes.modal} ${classes.open}`
            : `${classes.modal} ${classes.close}`
        }
      >
        <Menu />
      </div>
    </>
  );
};

export default MenuModal;
